import request from '@/utils/request'
import type * as CommonType from '@/typings/common'
import type * as SystemType from '@/typings/system'

// 获取所有角色列表
export async function getRolelist(params: CommonType.IPageSize) {
  return request('/api/v2/system/role_list', {
    method: 'get',
    data: params
  })
}

// 删除角色
export async function deleteRole(params: CommonType.IdParams) {
  return request('/api/v2/system/role_delete', {
    method: 'post',
    data: params
  })
}

interface ISaveRoleRequest {
  role: SystemType.IRoleInfoType
  list: { code: number }[]
}
// 新增/编辑角色
export async function saveRole(params: ISaveRoleRequest) {
  return request('/api/v2/system/role_save', {
    method: 'post',
    data: params
  })
}

// 获取角色权限详情
export async function getRolePermisssonList(params?: CommonType.IdParams) {
  return request('/api/v2/system/role_get', {
    method: 'get',
    data: params
  })
}

// 获取所有的权限菜单
export async function getPermissionMenuList() {
  return request('/api/v2/system/all_menu', {
    method: 'get',
    data: {}
  })
}
